<v2-row justifyContent="space-between" alignItems="center">
  <v2-row alignItems="center">
    <div class="leading">
      <ng-content select="[leading]"></ng-content>
    </div>

    <div>
      <div class="title">
        <ng-content select="[title]"></ng-content>
      </div>
      <v2-body-small-text color="medium-grey">
        {{ subtitle }}
      </v2-body-small-text>
    </div>
  </v2-row>

  <div class="trailing">
    <ng-content select="[trailing]"></ng-content>
  </div>
</v2-row>
